import type { LoginRequest } from '@jq4race/shared';

import type { MfaIntent, Session } from '../../domain/entities/session';
import type { AuthRepository } from '../../domain/ports/auth-repository';
import type { SessionFactory } from '../ports/session-factory';

export type LoginResult =
  | {
      kind: 'authenticated';
      session: Session;
    }
  | {
      kind: 'mfa-required';
      intent: MfaIntent;
      redirectTo: '/setup-mfa' | '/login-mfa';
    };

interface LoginUseCaseDeps {
  authRepository: AuthRepository;
  createSession: SessionFactory;
}

export async function loginUseCase(
  input: LoginRequest,
  deps: LoginUseCaseDeps,
): Promise<LoginResult> {
  const result = await deps.authRepository.login(input);

  if (result.mfaPending) {
    return {
      kind: 'mfa-required',
      intent: {
        mfaToken: result.mfaToken,
        setupRequired: result.setupRequired,
        email: input.email,
      },
      redirectTo: result.setupRequired ? '/setup-mfa' : '/login-mfa',
    };
  }

  const session = deps.createSession({ ...result, email: input.email });
  if (!session) throw new Error('invalid token in response');

  return { kind: 'authenticated', session };
}
